/* src/app/features/distribuicao-limites-agentes/distribuicao-limites-configuracao/distribuicao-limites-configuracao.component.scss */
#corpo-lista:hover {
  background-color: #f5f5f5;
}
/*# sourceMappingURL=distribuicao-limites-configuracao.component.css.map */
